var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34233 11.3333C2.02611 11.3333 1.75217 11.2297 1.5205 11.0223C1.28894 10.8151 1.1475 10.5568 1.09617 10.2473L0 2.4615H1.92317V1.20517C1.92317 0.872722 2.04089 0.588722 2.27633 0.353167C2.51178 0.117722 2.79572 0 3.12817 0H8.20517C8.53761 0 8.82156 0.117722 9.057 0.353167C9.29244 0.588722 9.41017 0.872722 9.41017 1.20517V2.4615H11.3333L10.2307 10.2473C10.1794 10.5568 10.0363 10.8151 9.80133 11.0223C9.56622 11.2297 9.29056 11.3333 8.97433 11.3333H2.34233ZM4.9795 8.69233L7.98467 5.7L7.27183 5.00383L4.98583 7.277L4.0615 6.359L3.34867 7.07183L4.9795 8.69233ZM2.923 2.4615H8.41033V1.20517C8.41033 1.14528 8.39106 1.09611 8.3525 1.05767C8.31406 1.01922 8.26494 1 8.20517 1H3.12817C3.06839 1 3.01928 1.01922 2.98083 1.05767C2.94228 1.09611 2.923 1.14528 2.923 1.20517V2.4615Z",
    fill: "#8790A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderGrey);
export default __webpack_public_path__ + "static/media/order-grey.3a0c38937d960bfeecabbedea582c57c.svg";
export { ForwardRef as ReactComponent };